function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import cn from 'classnames';
import { Typography, useIntentBehavior } from 'seagull';
import { fullName } from "../../../../infra/utils";
import { selectors } from "../../../../store/state-selectors";
import { useStore } from "../../../../store/store-context";
import styles from "./MobileSign.module.scss";
import { SignatureWithProgress } from "./SignatureWithProgress";
import { SignSlider } from "./SignSlider";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MobileSign(_ref) {
  let {
    relationship,
    disabled = false,
    intent,
    onSign
  } = _ref;
  const [percent, setPercent] = useState(0);
  const {
    getDisabled
  } = useIntentBehavior();
  const userFirstName = useStore(selectors.user.firstName) || null;
  const userLastName = useStore(selectors.user.lastName) || null;
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const isDisabled = disabledFromIntent || disabled;
  const typographyProps = isDisabled ? {
    skin: 'invertedStandard',
    className: styles.hint
  } : {
    className: cn(styles.hint, styles.enabled)
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [disabled || /*#__PURE__*/_jsx(SignatureWithProgress, {
      percent: percent,
      children: fullName(userFirstName, userLastName)
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.slider,
      children: [/*#__PURE__*/_jsx(SignSlider, {
        disabled: isDisabled,
        onChange: setPercent,
        onSign: onSign
      }), /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({}, typographyProps), {}, {
        style: {
          opacity: Math.max(1 - 6 * percent, 0)
        },
        children: relationship.isSample ? 'Approve test agreement' : 'Swipe to approve agreement'
      }))]
    })]
  });
}